import { mapBasePageProperties } from './basePagePropertiesMapper';
import logger from '3-foundation/Logging/logger';
import { getNews } from '3-foundation/News/repository';

export const mapNewsCatalogPageProperties = async (
	properties: Umbraco.BasePage,
	pageId: string,
	siteId: string,
	locale: string,
): Promise<Content.NewsCatalogPageProperties> => {
	try {
		const { items, tags, totalItems } = await getNews({
			filters: {
				parentId: pageId,
			},
			siteId,
			locale,
		});

		if (!items) throw new Error('No results from getNews');

		return {
			...(await mapBasePageProperties(properties, siteId, locale)),
			newsItems: items,
			filterTags: tags,
			totalNewsItems: totalItems,
		};
	} catch (e) {
		logger.error(`Could not map NewsCatalogPage Properties. \nCause: ${e.message}`, { cause: e });
		throw new Error(`Could not map NewsCatalogPage Properties. \nCause: ${e.message}`, { cause: e });
	}
};
